import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const poaEndpoint = "/api/proyectoEstructuracionTree";
const nodeRaiz = "DocumentosPOA";

// Misma validación de nombre de carpeta usada en FileManagerPOA.jsx
export const FOLDER_NAME_REGEX = /^[a-zA-Z0-9 _áéíóúÁÉÍÓÚñÑ.,()-´]+$/;

export const getFolderStats = async (ruta) => {
  try {
    const response = await axios.get(`${baseUrl}${poaEndpoint}/folderStats`, {
      params: { ruta },
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las estadísticas de la carpeta:", error);
    throw error;
  }
};

export const renameFolder = async (ruta, nuevoNombre, resourceInfo) => {
  try {
    const fd = new FormData();
    fd.append("ruta", ruta);
    fd.append("nuevoNombre", nuevoNombre);
    fd.append("nodeRaiz", nodeRaiz);
    fd.append("resourceInfo", JSON.stringify(resourceInfo));
    const response = await axios.post(`${baseUrl}/api/editNameDirectories`, fd, {
      headers: { "Content-Type": "multipart/form-data; charset=UTF-8" },
    });
    return response;
  } catch (error) {
    console.error("Error al renombrar la carpeta:", error);
    throw error;
  }
};

export const deleteFolder = async (dirPath, resourceInfo) => {
  try {
    const fd = new FormData();
    fd.append("dirPath", dirPath);
    fd.append("nodeRaiz", nodeRaiz);
    fd.append("resourceInfo", JSON.stringify(resourceInfo));
    const response = await axios.post(`${baseUrl}/api/delete-directory`, fd);
    return response;
  } catch (error) {
    console.error("Error al eliminar la carpeta:", error);
    throw error;
  }
};
